import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppAuthProvider } from './auth/AuthContext';
import LoginForm from './components/LoginForm';
import AppWrapper from './components/AppWrapper';
import AuthCallback from './components/AuthCallback';

// Component that renders the app content when authenticated
const AuthenticatedApp: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`min-h-screen bg-gray-50 transition-all duration-700 ease-out ${
      isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'
    }`}>
      <Routes>
        {/* Auth callback route */}
        <Route path="/auth/callback" element={<AuthCallback />} />
        
        {/* Main app route */}
        <Route path="/" element={
          <LoginForm>
            <AppWrapper />
          </LoginForm>
        } />
        
        {/* Redirect all other routes to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
};

// Main component that provides authentication context
const AppWithAuth: React.FC = () => {
  return (
    <AppAuthProvider>
      <AuthenticatedApp />
    </AppAuthProvider>
  );
};

export default AppWithAuth;
